exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner[data-v-579c08f2] {\n  padding: 1em 1em;\n}\n.b-tabs[data-v-579c08f2] {\n  background: #fff;\n}\n", ""]);

// exports
